<template>
    <el-dialog :visible="visible" width="40%" @close="handleClose" class="dialog" :close-on-click-modal="false" :title="title">
        <el-form ref="form" :model="form" label-width="100px" size="mini" :rules="rules">
            <el-form-item label="项目：" prop="cat">
                <el-select
                        v-model="form.cat"
                        filterable
                        allow-create
                        clearable
                        default-first-option
                        style="width: 100%"
                        placeholder="">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <el-input v-model="form.name">
                </el-input>
            </el-form-item>
<!--            <el-form-item label="医生级别：" prop="doctor">-->
<!--                <el-input v-model="form.doctor">-->
<!--                </el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="项目意义：" prop="content">-->
<!--                <el-input v-model="form.content"  type="textarea" :rows="4">-->
<!--                </el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="价格：" prop="fee">
                <el-input v-model="form.fee" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                </el-input>
            </el-form-item>
            <el-form-item label="排序：">
                <el-input v-model.number="form.sort">
                </el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="content">
                <el-input v-model="form.content"  type="textarea" :rows="4">
                </el-input>
            </el-form-item>
            <el-form-item style="padding: 20px;text-align: right">
                <el-button type="primary" @click="onSubmit">确 定</el-button>
                <el-button @click="handleClose">取 消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            visible: {
                default: false
            },
            form: {
                default: {}
            },
            title: {
                default: "添加/修改"
            },
        },
        data() {
            return {
                options:[
                    {
                        value: '实验室检查',
                        label: '实验室检查'
                    },
                    {
                        value: 'B超',
                        label: 'B超'
                    },
                    {
                        value: '多普勒',
                        label: '多普勒'
                    },
                    {
                        value: '胃肠镜',
                        label: '胃肠镜'
                    },
                    {
                        value: 'CT',
                        label: 'CT'
                    },
                    {
                        value: '妇科检查',
                        label: '妇科检查'
                    },
                    {
                        value: '核磁',
                        label: '核磁'
                    },
                    {
                        value: '心电室',
                        label: '心电室'
                    },
                    {
                        value: '功能检查',
                        label: '功能检查'
                    },
                    {
                        value: 'X线',
                        label: 'X线'
                    }
                ],
                rules: {
                    name: [
                        {required: true, message: '请输入', trigger: 'blur'},
                    ],
                    cat: [
                        {required: true, message: '请输入', trigger: 'blur'},
                    ],
                    fee: [
                        {required: true, message: '请输入石化价格', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            async onSubmit() {
                var va = false
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        va = true
                    }
                })
                if (!va) {
                    return
                }
                try {
                    let url = `enterprise/shihua/package/custom`
                    const resp = await this.$http.post(url, this.form)
                    if (resp.data.code != 200) {
                        this.$message.error(resp.data.message)
                    } else {
                        this.$message.success("提交成功！")
                    }
                } catch (e) {
                    this.$message.error(e.message)
                }
                this.$emit('update')
            },
            handleClose() {
                this.$emit('close')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .dialog ::v-deep .el-dialog__body {
        padding: 10px 20px;
    }

    .tijian {
        border: 1px solid #c0c4cc;
        padding: 5px;
    }

    .title {
        display: flex;
        align-items: center;
        padding: 10px;

        .title-text {
            text-align: center;
            border-bottom: 1px solid #EBEEF5;
            border-top: 1px solid #EBEEF5;
            padding: 10px;
        }
    }

    ::v-deep .el-table .el-table__cell {
        padding: 6px 0;
    }

    .flex {
        display: flex;
    }

    .btn {
        justify-content: space-between;
        padding: 10px 0;
    }

    .border-bottom {
        border-bottom: 1px solid #EBEEF5;
    }

    .text-center {
        text-align: center;
        padding: 5px 0;
    }

    .align-items {
        align-items: center;
    }

    .text-group {
        display: grid;
        padding-right: 10px
    }
</style>
